import { z } from 'zod';

export const getDivisionsSchema = z.array(
  z.object({
    id: z.string(),
    code: z.string().optional(),
    name: z.string().optional(),
    origin: z.number(),
    originString: z.string().optional(),
    isFromManager: z.boolean(),
    isActive: z.boolean().optional(),
  })
);

export type GetDivisionsResponse = z.infer<typeof getDivisionsSchema>;
